// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__Bv1F6"};